<template>
  <div class="Pie-wrap" ref="chart">
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: "Pie",
  props: [
    'info',
    'otherInfoMethod'
  ],
  components: {

  },
  data() {
    return {
      myChart: null,
      otherInfo: {
        total: 0,
        unit: ''
      },
    };
  },
  computed: {
  },
  watch: {
    info: {
      handler(val){
        this.myChart && this.myChart.dispose()
        this.$nextTick(() => {
          this.initChart()
        })
      },
      deep: true,
      immediate: true,
    }
  },
  created() {
    /* 
    
      this.info = {
        name: '示例',
        radius: ['40%', '70%'], // 格式：['40%', '70%']
        showLabel: true,  // 默认为true
        showPercent: true,
        showLabelRate: 5, //比率大于百分之5的时候展示label
        data: [ 
          // 数据配置同官方文档（https://echarts.apache.org/zh/option.html#series-pie.data）
          // 添加了color属性和showLabel属性
          // color决定对应部分的图形颜色、label颜色和labelLine的颜色 
          { value: 1048, name: '展示标签', color: 'skyblue'},
          { value: 735, name: '不展示标签', color: 'pink'},
          { value: 735, name: '使用官方配置',
            itemStyle: {
              color: 'deepskyblue'
            },
            custom: {}
          },
        ],
        custom: {}, // 如果有较大的配置改动，可通过该配置（官方文档）进行覆盖
      }
    
    
    */
    
  },
  mounted() {
  },
  methods: {
    initChart(){
      let {
        name = '',
        data = [],
        radius = ['35%', '60%'],
        showLabel = true,
        showPercent = true,
        showLabelRate = 5,
        custom = {},
        labelBreak = false
      } = this._.cloneDeep(this.info || {})


      let maxObj = this._.maxBy(data, x => {
        return Math.abs(x.value)
      })
      let unit = Math.abs(maxObj?.value) >= 100000000 ? '亿' : Math.abs(maxObj?.value) >= 10000 ? '万' : ''
      let total = 0
      let pieData = data.map(x => {
        x.label = {
          show: x.value != 0 && showLabel,
        }
        if(x.color) {
          x.label.color =  x.color
        }
        x.itemStyle = x.color ? {color: x.color, borderWidth: 2, boderColor: '#fff'} : {}
        x.minus = x.value < 0
        let {value} = this.fmt(x.value, {isObject: true, fixedUnit: unit})
        total += (x.value * 1)
        x.value = Math.abs(value)
        x = this._.merge(x, x.custom || {})
        return x
      });

      this.otherInfo.total = this.fmt(total, {isObject: true, fixedUnit: unit}).value  // 可能为负
      this.otherInfo.unit = unit
      this.otherInfoMethod?.(this.otherInfo)
      let option = {
        tooltip: {
          trigger: 'item',
          formatter:function(params){
            return `${params.name} : ${params?.data?.minus ? '-' : ''}${(params.value * 1).toLocaleString()}${unit} (${params.percent}%)`
          },
        },
        legend: {
          bottom: 0,
          left: 'center',
          padding: 0,
          selectedMode: false,
        },
        grid: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          containLabel: true
        },
        emphasis: {
          disabled: true
        },
        series: [ 
          {
            name,
            type: 'pie',
            radius,
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 1
            },
            label: {
              formatter:function(params){
                return `${params.name}${labelBreak ? '\n' : ''}(${params?.data?.minus ? '-' : ''}${(params.value * 1).toLocaleString()}${unit})`
              },
              alignTo: 'labelLine',
              minMargin: 5,
              lineHeight: 15,
            },
            percentPrecision: 0,
            labelLayout: {
              draggable: true
            },
            labelLine: {
              show: showLabel,
              length: 10,
              length2: 80,
            },
            data: pieData
          },
        ]
      };
      option = this._.merge(option, custom)
      if(showPercent){
        let obj = this._.cloneDeep(option.series[0])
        let {value: handledTotal} = this.fmt(total, {isObject: true, fixedUnit: unit})
        let another = this._.merge(obj, {
          label: {
            color: '#fff',
            position: 'inside',
            formatter: '{d}%',
          },
          labelLayout: {
            fontSize: 10,
            draggable: false,
          },
          data: pieData.map(x => {
            return {
              ...x,
              itemStyle: {
                color: 'transparent',
              },
              label: {
                // 占比大于5%的显示
                show: this.$D(this.$D(Math.abs(x.value), Math.abs(handledTotal), {op: 'div'}), 100, {op: 'mul'}) > showLabelRate,
                color: '#fff'
              }
            }
          })
        })
        option.series.push(another)
      }
      if(!this.$refs.chart){return}
      this.myChart = echarts.init(this.$refs.chart)
      this.myChart.setOption(option)
    },
    
  }
};
</script>

<style scoped lang="less">
.Pie-wrap{
  width: 100%;
  height: 100%;
}
</style>